<div class="container">
  <ng-container *ngFor="let examQuestion of exam.examQuestions; let i = index; let last = last">
    <div class="question-row" (click)="toggleExpand(examQuestion.id)">
      <div>
        Aufgabe {{i + 1}}
      </div>
      <div></div>
      <div>{{examQuestion.score}}%</div>
    </div>
    <div *ngIf="expandedQuestions[examQuestion.id]" class="expanded-content">
      <h3>Aufgabe</h3>
      <p>{{examQuestion.question}}</p><br>
      
      <h3>Deine Lösung</h3>
      <div [innerHTML]="examQuestion.userAnswer"></div>

      <h3>Was hat zur vollen Punktzahl gefehlt?</h3>
      <p>{{examQuestion.feedback}}</p>
    </div>
    <div *ngIf="!last" class="divider"></div>
  </ng-container>
</div>